export const numberSpliter = (msisdn) => {
  return `${msisdn.replace(/(\d{3})(\d{2})(\d{2})/, '$1 $2 $3')}`;
};

export const getLocalValue = (key) => {
  if (typeof window !== 'undefined') {
    return window.localStorage.getItem(key);
  }
};

export const numberSplitter = (msisdn) => {
  return `${msisdn.replace(/(\d{3})(\d{2})(\d{2})/, '$1-$2-$3')}`;
};

export const nextWindowsChecker = () => {
  return typeof window !== 'undefined';
};

export const gtmVirtualPageView = (event) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer?.push({
    event,
  });
};

export const extractItemId = (path) => {
  if (!path) return null;

  const urlParts = path.substring(1).split('/');
  const lastSegment = urlParts[urlParts.length - 1];

  const itemId = lastSegment.split('?')[0];

  return itemId || null;
};

export const pickRandomArrayValue = (arr) => {
  if (!Array.isArray(arr) || arr?.length === 0) {
    throw new Error('Input must be a non-empty array of arrays.');
  }

  const randomIndex = Math.floor(Math.random() * arr?.length);

  return arr[randomIndex];
};
